import { render, staticRenderFns } from "./PostmortemDetails.vue?vue&type=template&id=5c3d3747&scoped=true&"
import script from "./PostmortemDetails.vue?vue&type=script&lang=js&"
export * from "./PostmortemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d3747",
  null
  
)

export default component.exports